const holders = new Set();
const listeners = new Set();

const TEXT_INPUT_TYPES = new Set([
  'text',
  'search',
  'email',
  'password',
  'tel',
  'url',
  'number',
  'date',
  'datetime-local',
  'time',
  'month',
  'week',
]);

export const RELOAD_GUARD_KEY = 'app-update-reload-at';
export const RELOAD_GUARD_MS = 60_000;

let updatePending = false;

function notifyHoldChange() {
  for (const listener of listeners) listener();
}

export function holdAppUpdate() {
  const token = {};
  holders.add(token);
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders.delete(token);
    notifyHoldChange();
  };
}

export function onAppUpdateHoldChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function isTextEntryFocused(doc = globalThis.document) {
  const el = doc?.activeElement;
  if (!el || el === doc.body || el === doc.documentElement) return false;
  if (el.isContentEditable) return true;
  const tag = el.tagName;
  if (tag === 'TEXTAREA') return true;
  if (tag !== 'INPUT') return false;
  const type = (el.getAttribute('type') || 'text').toLowerCase();
  return TEXT_INPUT_TYPES.has(type);
}

export function isAppUpdateHeld(doc = globalThis.document) {
  return holders.size > 0 || isTextEntryFocused(doc);
}

export function markUpdatePending() {
  updatePending = true;
}

export function hasPendingUpdate() {
  return updatePending;
}

export function clearPendingUpdate() {
  updatePending = false;
}

export function moduleScriptSrc(html) {
  if (typeof html !== 'string') return null;
  const tags = html.match(/<script\b[^>]*>/gi) || [];
  for (const tag of tags) {
    if (!/\btype\s*=\s*["']module["']/i.test(tag)) continue;
    const src = tag.match(/\bsrc\s*=\s*["']([^"']+)["']/i);
    if (src) return src[1];
  }
  return null;
}

export function scriptUrlsMatch(currentHref, nextSrc, baseHref) {
  if (!currentHref || !nextSrc) return true;
  try {
    return new URL(currentHref, baseHref).href === new URL(nextSrc, baseHref).href;
  } catch {
    return true;
  }
}

export function indexHtmlUrl(baseUrl, origin) {
  const base = typeof baseUrl === 'string' && baseUrl.length > 0 ? baseUrl : '/';
  const prefix = base.endsWith('/') ? base : `${base}/`;
  return new URL(`${prefix}index.html`, origin).href;
}

export function currentModuleScript(doc = globalThis.document) {
  const el = doc?.querySelector?.('script[type="module"][src]');
  return el?.src || null;
}

export function reloadGuardOpen(now = Date.now(), storage = globalThis.sessionStorage) {
  try {
    const stored = storage?.getItem(RELOAD_GUARD_KEY);
    const last = Number(stored);
    if (stored && Number.isFinite(last) && now - last < RELOAD_GUARD_MS) return false;
    storage?.setItem(RELOAD_GUARD_KEY, String(now));
    return true;
  } catch {
    return true;
  }
}
